<template>
  <div
    class="select-wrapper relative"
    @click.stop="toggle()"
    ref="select"
    :tabindex="tabindex"
    @blur="close"
  >
    <div class="select" :class="{ selected: this.selected.length }">
      <div class="flex flex-row items-center overflow-hidden gap-2 flex-1">
        <div
          v-if="haveIcon(getItem(selectedItem))"
          v-html="getItem(selectedItem).html"
        ></div>
        <p class="selected_text">
          {{ selectedText }}
        </p>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="min-w-[18px]"
        :class="[{ expanded: visible }]"
      >
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </div>
    <div class="option_list overflow-hidden" :class="{ hidden: !visible }">
      <ul v-if="searchable">
        <li class="flex flex-row gap-2 items-center">
          <Input
            :placeholder="$t('input.filter.placeholder')"
            v-model="search"
            @blur="inputBlur"
            class="dark:!bg-dark-mode-100"
            :darkModeClass="true"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
            >
              <circle
                cx="5.88344"
                cy="5.88329"
                r="4.49428"
                stroke="#A8B0BC"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.00928 9.24255L10.7713 11"
                stroke="#A8B0BC"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Input>
        </li>
      </ul>
      <ul>
        <li v-if="searchable && !filteredOptions.length">
          <span class="text-[12px] font-medium">
            {{ $t("input.no_result.filter") }}
          </span>
        </li>
        <li
          class="flex flex-row gap-2 items-center relative"
          :class="{ current: isSelected(item.value) }"
          v-for="item in filteredOptions"
          :key="item.value"
          @click="select(item.value)"
        >
          <div v-if="haveIcon(item)" v-html="item.html"></div>
          <p v-if="item.text != null" class="text-xs flex-1">{{ item.text }}</p>
          <div
            v-if="multiple"
            :class="{ selected_item: isSelected(item.value) }"
            class="indicator ml-auto"
          ></div>
          <div
            v-else
            :class="{ show_indicator: isSelected(item.value) }"
            class="indicator--single"
          ></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Input from "@/components/Input";
export default {
  name: "Select",
  components: { Input },
  props: {
    options: {
      type: Array,
      required: true,
      default: () => [{ value: 0, text: "Select" }],
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    value: {
      required: true,
    },
    defaultText: {
      type: String,
      default: "Select",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    maxTextWidth: {
      type: String,
    },
  },
  data() {
    return {
      visible: false,
      search: "",
      selected: [],
    };
  },
  methods: {
    toggle() {
      this.visible = !this.visible;
    },
    close(event) {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.visible = false;
      }
    },
    inputBlur(event) {
      if (!event.relatedTarget?.contains(event.currentTarget)) {
        this.visible = false;
      }
    },
    select(option) {
      if (this.multiple) {
        if (this.isSelected(option)) {
          this.selected = this.selected.filter((item) => item !== option);
        } else {
          this.selected.push(option);
        }
        this.$emit("input", this.selected);
        this.toggle();
      } else {
        this.selected = option;
        this.$emit("input", option);
      }
    },
    haveIcon(item) {
      return item?.html != null;
    },
    isSelected(value) {
      return this.multiple
        ? this.selected.filter((item) => item === value).length > 0
        : this.selected === value;
    },
    getItem(value) {
      return this.options?.find((item) => item.value === value) ?? null;
    },
  },
  computed: {
    selectedText() {
      if (this.multiple) {
        let text = this.value.length ? this.getItem(this.value[0]).text : "";
        this.value.slice(1).forEach((element) => {
          text = `${text}, ${this.getItem(element).text}`;
        });
        return text.length ? text : this.defaultText;
      }
      return this.value.toString().length > 0 &&
        this.options.map((item) => item.value).includes(this.value)
        ? this.getItem(this.value).text
        : this.defaultText;
    },
    selectedItem() {
      if (this.multiple) {
        return this.value[0] ?? null;
      }
      return this.options.find((item) => item.value === this.value) ?? null;
    },
    filteredOptions() {
      return this.searchable
        ? this.options.filter((item) =>
            item.text.turkishToLower().includes(this.search.turkishToLower())
          )
        : this.options;
    },
  },
  watch: {
    value: {
      handler(val) {
        if (this.selectedItem !== null) {
          this.$emit("change", val);
        }
        this.selected = val;
      },
      immediate: true,
    },
  },
};
</script>
<style scoped>
@import "index.module.css";
</style>
